import { Helmet } from "react-helmet-async";

export default function PageSEO({ title, description, path }) {
  const baseUrl = "https://www.ssvent.com";
  const siteName = "Shree Siddhivinayak Enterprise";
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Laboratory & Scientific Solutions`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {path && <link rel="canonical" href={`${baseUrl}${path}`} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {path && <meta property="og:url" content={`${baseUrl}${path}`} />}
    </Helmet>
  );
}
